// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35GNs","colMin":"styles_colMin__3k2xI"};